import React, { useState, useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BN from 'bignumber.js';
import stylesParent from '../../../styles/frame/frame.module.scss';
import Header from '../../../../../../../components/Stake/header';
import { formatToken } from '../../../../../../../helpers/token-helper';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import * as gamerStakeActions from '../../../../../../../actions/gamer-stake-actions-polygon';
import GamerIcon from '../../../../../../../assets/images/GAMER.png';
import { toPowerOf } from '../../../../../../../blockchain/config';
import TextRow from '../../../../../../../components/Stake/frame/settings/text-row';
import InputRow from '../../../../../../../components/Stake/frame/settings/input-row';
import FooterBlock from '../../../../../../../components/Stake/frame/settings/footer-block';

const StakeSettings = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();

  const [amount, setAmount] = useState(new BN(10000).times(toPowerOf).toString(10));
  const [inputValue, setInputValue] = useState(amount);

  useEffect(() => {
    setInputValue(+new BN(amount).div(toPowerOf).toFixed(2, BN.ROUND_DOWN));
  }, [amount]);

  const balance = useSelector((state) => state.token.gamerPolygonBalance);

  const { stakeBalance, unstakedBalance, apr } = useSelector(
    (state) => state.GAMERPOLYGONstake.stake,
  );

  const isNotFirstFrame = [stakeBalance, unstakedBalance].some((value) => value !== '0');
  const onClickBack = isNotFirstFrame ? () => dispatch(gamerStakeActions.stakeReset()) : null;

  const estimatedDailyRewards = useMemo(() => {
    if (!apr) {
      return null;
    }
    return new BN(amount)
      .div(toPowerOf)
      .times(apr / 100)
      .div(365)
      .toFixed(0, BN.ROUND_DOWN);
  }, [amount, apr]);

  const handleAmountChange = (value) => {
    setAmount(value.amount);
  };

  const yourBalance = `${formatToken(balance)} GAMER`;
  const totalStake = `${formatToken(stakeBalance)} GAMER`;
  const percentInOMText = `${apr}%`;
  const estimatedDailyRewardText = `${estimatedDailyRewards} GAMER`;

  return (
    <>
      <Header icon={GamerIcon} title={'GAMER-Staking'} onClickBack={onClickBack} />
      <div className={stylesParent.cardContent} style={{ color: colors.text }}>
        <div>
          <TextRow
            title='Your balance:'
            text={yourBalance}
            isAccent={false}
            isLargeMargin={false}
          />
          <TextRow
            title='Current Total Stake:'
            text={totalStake}
            isAccent={true}
            isLargeMargin={true}
          />
        </div>
        <div>
          <InputRow
            title='Stake Amount'
            toPowerOf={toPowerOf}
            handleAmountChange={handleAmountChange}
            currency='GAMER'
            balance={balance}
            inputValue={inputValue}
          />
          <FooterBlock
            estimatedDailyRewardText={estimatedDailyRewardText}
            percentInOMText={percentInOMText}
            nextButtonClick={() => dispatch(gamerStakeActions.stakeAttention({ amount }))}
          />
        </div>
      </div>
    </>
  );
};

export default StakeSettings;
